__webpack_require__.p = "https://assets-01.periodica.press/fba428b-25161122377/";